// src/components/Landing/Index.js

import React from 'react';
import { Box } from '@mui/material';
import Section from './Section';
import getSections from './Resources/sections';
import { useTranslation } from 'react-i18next';

import './IndexStyles.scss';

const Index = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ bgcolor: 'background.default', pb: 4 }}>
            {getSections(t).map((section) => (
                <Section key={section.id} {...section} />
            ))}
        </Box>
    );
}

export default Index;
